<template>
    <div>
        <ul>
            <li class="form-label">{{ $t('Centrex Type') }}</li>
            <li>
                <cic-select
                    id="route_mapping_type"
                    :enabled="editing"
                    :options="types"
                    :value="route.mappingType"
                    @input="(val) => updateMappingType(val)"
                />
            </li>
            <template v-if="route.mappingType === 2">
                <li class="form-label">{{ $t('Call Treatment') }}</li>
                <li>
                    <cic-select
                        id="route_mapping"
                        :enabled="editing"
                        :options="treatments.map((x) => ({ value: x.treatmentId, label: x.name }))"
                        :placeholder="$t('Please select...')"
                        :value="route.mappingId"
                        @input="(val) => updateFieldValue('mappingId', val)"
                    />
                </li>
            </template>
            <template v-else-if="route.mappingType === 1">
                <li class="form-label">{{ $t('User') }}</li>
                <li>
                    <cic-select
                        id="route_mapping"
                        :enabled="editing"
                        :options="
                            users.map((x) => ({
                                value: x.userId,
                                label: `${x.firstName} ${x.lastName} (${x.username})`,
                            }))
                        "
                        :placeholder="$t('Please select...')"
                        :value="route.mappingId"
                        @input="(val) => updateFieldValue('mappingId', val)"
                    />
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'Centrex',
        components: {
            CicSelect,
        },
        props: {
            accessType: {
                type: Number,
                default: 0,
            },
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            treatments: {
                type: Array,
                required: true,
            },
            users: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        computed: {
            types() {
                const types = [];
                types.push({ value: 2, label: this.$t('Call Treatment') });
                if ([0, 1].includes(this.accessType)) {
                    types.push({ value: 1, label: this.$t('User') });
                    types.push({ value: 3, label: this.$t('Voicemail Retrieval') });
                }

                return types;
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
            updateMappingType(val) {
                this.updateFieldValue('mappingId', null);
                this.$nextTick(() => {
                    this.updateFieldValue('mappingType', val);
                });
            },
        },
    };
</script>
